// Получение данных пользователя.
import type {BankTransferCredentialsData} from '@frontend/types/PublicData'
import {ApiRequestService} from 'swayok-react-mdb-ui-kit/services/ApiRequestService'
import type {
    AdCategory,
    AdLocation,
} from '../modules/public/ads/AdsModuleTypes'
import type {ApiResponseData} from '../types'

// API для получения публичных данных, не связанных с конкретным модулем.
export const PublicDataApi = {

    // Запрос данных авторизованного пользователя.
    async getBankTransferCredentials(this: void): Promise<BankTransferCredentialsData> {
        return ApiRequestService
            .get<BankTransferCredentialsData>('/v1/info/bank-transfer-credentials')
            .then(response => response.data)
    },

    // Получить древовидный список категорий.
    async getCategoriesTree(abortController?: AbortController): Promise<AdCategory[]> {
        return ApiRequestService
            .get<CategoriesTreeResponseData>(
                '/v1/categories/tree',
                undefined,
                undefined,
                abortController
            )
            .then(response => response.data.categories)
    },

    // Получить древовидный список категорий.
    async getLocationsTree(abortController?: AbortController): Promise<LocationsTreeResponseData> {
        return ApiRequestService
            .get<LocationsTreeResponseData>(
                '/v1/locations/tree',
                undefined,
                undefined,
                abortController
            )
            .then(response => response.data)
    },
}


interface CategoriesTreeResponseData extends ApiResponseData {
    categories: AdCategory[]
}

interface LocationsTreeResponseData extends ApiResponseData {
    locations: AdLocation[]
    levels: string[]
}
